import {type IconType, Loader} from '../../icons';

/**
 * Custom hook to manage the state and behavior of a button component, particularly for handling loading states and icon display.
 *
 * @param isLoading Indicates whether the button is in a loading state. If true, the button will display a loading spinner instead of the provided icon.
 * @param icon      The icon to be displayed on the button. If `isLoading` is true, this will be overridden by a loading spinner icon.
 * @returns An object containing the `Icon` component to be rendered on the button, which will be either the provided icon or a loading spinner based on the `isLoading` state.
 */
export const useButton = (isLoading: boolean, icon: IconType | undefined) => {
    const Icon = isLoading ? Loader : icon;

    return {Icon};
};